module.exports = __webpack_public_path__ + "static/media/Callaghan_front1-1.9b1d1102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/Callaghan_front1-1.jpg
// module id = 413
// module chunks = 0